import Button from 'components/ui/Button';
import { styled } from 'styled-components';
import { getCommandKeyName } from 'utils/commonUtils';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${(props) => `${props.theme.global.bgColor}90`};
  backdrop-filter: blur(4px);
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
`;

const Description = styled.span`
  font-size: 16px;
  text-align: center;
  margin-bottom: 16px;
`;

const ButtonView = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

interface UpdateBlurProps {
  onSaveClick: () => void;
  onCloseBlur: () => void;
}

const UpdateBlur = ({ onSaveClick, onCloseBlur }: UpdateBlurProps) => {
  return (
    <Container>
      <Title>변경사항이 있어요</Title>
      <Description>프로젝트를 저장하면 소스코드를 갱신할 수 있어요</Description>
      <ButtonView>
        <Button onClick={onCloseBlur} $isReverse>
          괜찮아요
        </Button>
        <Button onClick={onSaveClick}>{`저장 (${getCommandKeyName('S')})`}</Button>
      </ButtonView>
    </Container>
  );
};

export default UpdateBlur;
